import React, { useEffect, useState } from 'react';
import { PopupContainer } from './styled';
import { useRouter } from 'next/router';
import { getScreenName } from '../../../Utils/helper';
import { fireEvent } from '../../../Utils/fireEvent';
import HealthBundle from '../../Product/HealthBundle/HealthBundle';
import BuyNowButton from '../BuyNowButton';

const PackBottomPopup = (props) => {
  const {
    addToCart,
    variantData,
    productData,
    productPriceData,
    userType,
    handleClose,
    isVariantPopup,
  } = props;
  const [userSelectedVariant, setUserSelectedVariant] = useState(3928);
  const [openPackPopup, setOpenPackPopup] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(productData?.id);
  const [addProductToCartOnVariantClick, setAddProductToCartOnVariantClick] =
    useState(false);

  useEffect(() => {
    fireEvent({
      category: 'viewed_popup',
      parent: 'Lactomama pack selector',
      screen_name: getScreenName(),
    });
  }, []);

  const openChooseLactoMamaPopup = () => {
    setOpenPackPopup(true);
  };

  const variantType =
    productData?.variantOption?.find((option) => option.variant_type !== 'Size')
      ?.variant_type || '';

  return (
    <PopupContainer>
      <h4>Choose your {variantType ? { variantType } : 'pack'}</h4>
      <div className="seperator" />
      <HealthBundle
        isPopUp={true}
        lactoMamaCategory={true}
        productId={userSelectedVariant}
        data={productData?.variantData}
        setSelectedVariant={(variantSelection) => {
          setSelectedVariant(variantSelection);
          setUserSelectedVariant(variantSelection);
        }}
        variantPriceData={productPriceData?.variantOption?.[0]?.data}
        setAddProductToCartOnVariantClick={setAddProductToCartOnVariantClick}
        handleClose={handleClose}
      />

      <BuyNowButton
        userType={userType}
        selectedVariant={selectedVariant}
        newProductData={productData?.variantData.find(
          (variant) => variant.id === userSelectedVariant,
        )}
        lactoMama={true}
        userSelectedVariant={userSelectedVariant}
        openChooseLactoMamaPopup={openChooseLactoMamaPopup}
        addProductToCartOnVariantClick={addProductToCartOnVariantClick}
        setAddProductToCartOnVariantClick={setAddProductToCartOnVariantClick}
        variantData={productData?.variantData}
        handleClose={handleClose}
        isVariantPopup={isVariantPopup}
      />
    </PopupContainer>
  );
};

export default PackBottomPopup;
